import { OpenPanel } from '@openpanel/web';
import { createContext, FC, ReactNode, useMemo } from 'react';

interface OpenPanelContextValue {
  openPanel: OpenPanel;
}

export const OpenPanelContext = createContext<OpenPanelContextValue | undefined>(undefined);

interface OpenPanelProviderProps {
  children: ReactNode;
  clientId: string;
  clientSecret?: string;
}

export const OpenPanelProvider: FC<OpenPanelProviderProps> = ({ children, clientId, clientSecret }) => {
  const openPanel = useMemo(() => {
    return new OpenPanel({
      clientId,
      clientSecret,
      trackScreenViews: true,
      trackOutgoingLinks: true,
      trackAttributes: true,
    });
  }, [clientId, clientSecret]);

  return <OpenPanelContext.Provider value={{ openPanel }}>{children}</OpenPanelContext.Provider>;
};
